export default [
  {
    path: 'salesman-and-cstomer-relation',
    name: 'SalesmanAndCustomerRelation',
    meta: {
      isDynamic: true,
      id: '业务员与客户关系',
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "SalesmanAndCustomerRelation" */ '@/views/CustomerManage/SalesmanAndCustomerRelation/SalesmanAndCustomerRelation.vue'
      )
  },
  {
    path: 'edit-customer-manage',
    name: 'EditCustomerManage',
    meta: {
      inTab: false
    },
    component: () =>
      import(
        /* webpackChunkName: "EditCustomerManage" */ '@/views/CustomerManage/EditCustomerManage/EditCustomerManage.vue'
      )
  },
  {
    path: 'distributor-customer-manage',
    name: 'DistributorCustomerManage',
    meta: {
      isDynamic: true,
      id: '发货方与客户关系',
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "DistributorCustomerManage" */ '@/views/CustomerManage/DistributorCustomerManage/DistributorCustomerManage.vue'
      )
  }
];
